import React from 'react'
import { CircularProgress, Stack, Typography } from '@mui/material'

import { GRAY_700 } from 'constants/styling/theme'

interface Props {
  /** What is loading, said to the client. */
  message: string
  /** `xs` sits under a form field; `sm` fills a section. */
  size?: 'xs' | 'sm'
}

/** A section still waiting for its data: a spinner and what it waits for, announced to screen readers. */
export const PfInlineLoading: React.FC<Props> = ({ message, size = 'sm' }) => (
  <Stack role="status" direction="row" gap={0.8} alignItems="center">
    <CircularProgress size={size === 'xs' ? 14 : 16} aria-hidden />
    <Typography variant={size === 'xs' ? 'text-xs' : 'text-sm'} color={GRAY_700}>
      {message}
    </Typography>
  </Stack>
)
